/**
 * <s-sticky-atc> — add-to-cart bar pinned to the bottom of the viewport.
 *
 * Shows once the main product form's `[data-sticky-atc-anchor]` (placed right after the
 * add-to-cart button) has scrolled above the viewport, and hides again when the buyer
 * scrolls back up. While hidden the bar is `inert` so it never takes focus.
 * The bar's button submits the main product form through its `form` attribute, so
 * <s-product-form> handles the add exactly like the main button.
 */
class SStickyAtc extends HTMLElement {
  #observer;

  connectedCallback() {
    const anchor = this.closest('[data-product-form]')?.querySelector('[data-sticky-atc-anchor]');
    if (!anchor || !('IntersectionObserver' in window)) return;

    this.#observer = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.toggleAttribute('data-visible', show);
      this.inert = !show;
    });
    this.#observer.observe(anchor);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-sticky-atc')) {
  customElements.define('s-sticky-atc', SStickyAtc);
}
